/* eslint-disable */
// 所有引入的第三方插件
import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import Vmodal from 'vue-js-modal' // https://github.com/euvl/vue-js-modal
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VideoPlayer from 'vue-video-player' 
 

Vue.filter('time_sort', function (value, formatString) {
  var now_time = new Date().getTime() / 1000;
  var c_time = new Date(value).getTime() / 1000;
  c_time -= now_time;
  if (c_time <= 0) {
    return '已结束!'
  } else {
    var dd, hh, mm, ss = null;
    dd = Math.floor(c_time / 60 / 60 / 24);
    hh = Math.floor((c_time / 60 / 60) % 24);
    mm = Math.floor((c_time / 60) % 60);
    ss = Math.floor((c_time) % 60);
    dd = dd < 10 ? '0' + dd : dd;
    hh = hh < 10 ? '0' + hh : hh;
    mm = mm < 10 ? '0' + mm : mm;
    ss = ss < 10 ? '0' + ss : ss;
    return dd + "天" + hh + "小时" + mm + "分" + ss + "秒";
  }
})
Vue.filter('time_sort2', function (value, formatString) {
  if(!value) return '--';  
  let str = value * 60
    var dd, hh, mm, ss = null;
  dd = Math.floor(str / 60 / 60 / 24);
  hh = Math.floor((str / 60 / 60) % 24);
  mm = Math.floor((str / 60) % 60);
  ss = Math.floor((str) % 60);
    dd = dd < 10 ? '0' + dd : dd;
    hh = hh < 10 ? '0' + hh : hh;
    mm = mm < 10 ? '0' + mm : mm;
    ss = ss < 10 ? '0' + ss : ss;
    return dd + "天" + hh + "小时" + mm + "分" + ss + "秒"; 
})
Vue.filter('time_sort3', function (value, formatString) {
  if(!value) return '--';  
    var dd, hh, mm, ss = null;
  dd = Math.floor(value / 60 / 60 / 24);
  hh = Math.floor((value / 60 / 60) % 24);
  mm = Math.floor((value / 60) % 60);
  ss = Math.floor((value) % 60);
    dd = dd < 10 ? '0' + dd : dd;
    hh = hh < 10 ? '0' + hh : hh;
    mm = mm < 10 ? '0' + mm : mm;
    ss = ss < 10 ? '0' + ss : ss;
    return hh + ":" + mm + ":" + ss ; 
})
Vue.filter('time_sort4', function (value, formatString) {
  if (!value) return '--';
  let txt1 = value.slice(0, 4);
  let txt2 = value.slice(4, 6);
  let txt3 = value.slice(6, 8);
  let txt4 = value.slice(8, 10);
  let txt5 = value.slice(10, 12);
  let txt6 = value.slice(12, 14);
  let str = txt1 + '/' + txt2 + '/' + txt3 + ' ' + txt4 + ':' + txt5 + ':' + txt6;
  return str;
})

Vue.use(VueLazyload, {
  preLoad: 1.3, // 预加载
  error: 'dist/error.png',  // 图片显示错误图片
  loading: 'dist/loading.gif', // 图片loading图片
  attempt: 1 // 重新加载次数
})
Vue.use(VueAwesomeSwiper)
Vue.use(Vmodal, { dynamic: true }) // 支持动态创建modal 动态创建的时候 一定要在当前组件下面引入此标签 <modals-container />  

// 添加时间过滤器 引入moment.js
Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern);
});